import React from "react";
import { Card, CardMedia, CardContent, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

/**
 * ServiceCard optimizado con React.memo
 * Solo se re-renderiza si las props cambian
 */
const ServiceCard = React.memo(
  ({ service, onClick, variants }) => {
    return (
      <motion.div
        initial="hidden"
        whileInView="visible"
        variants={variants}
        viewport={{ once: true }}
        style={{ height: "100%" }}
      >
        <Card
          onClick={() => onClick(service.key)}
          className="glass-effect"
          sx={{
            cursor: "pointer",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            borderTop: "3px solid",
            borderColor: "primary.main",
            transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            "&:hover": {
              transform: "translateY(-8px)",
              borderColor: "secondary.main",
              boxShadow: (theme) =>
                `0 16px 40px ${theme.palette.primary.main}33`,
              "& .card-cta": { opacity: 1, transform: "translateX(4px)" },
              "& .card-image": { transform: "scale(1.04)" },
            },
          }}
        >
          <Box sx={{ overflow: "hidden" }}>
            <CardMedia
              component="img"
              height="200"
              image={service.image}
              alt={service.title}
              loading="lazy"
              className="card-image"
              sx={{
                transition: "transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
              }}
            />
          </Box>
          <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 1 }}>
              {service.title}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ flexGrow: 1, mb: 1.5 }}
            >
              {service.description}
            </Typography>
            <Box
              className="card-cta"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                color: "primary.main",
                opacity: 0,
                transition: "opacity 0.25s ease, transform 0.25s ease",
                transform: "translateX(0)",
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 700 }}>
                Ver detalles
              </Typography>
              <ArrowForwardIcon sx={{ fontSize: 14 }} />
            </Box>
          </CardContent>
        </Card>
      </motion.div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.service.key === nextProps.service.key &&
      prevProps.service.title === nextProps.service.title &&
      prevProps.service.description === nextProps.service.description &&
      prevProps.onClick === nextProps.onClick
    );
  }
);

ServiceCard.displayName = "ServiceCard";

export default ServiceCard;
